import { FormHelperText, TextField } from '@mui/material';
import FormControl, { FormControlPropsSizeOverrides } from '@mui/material/FormControl';
import { OverridableStringUnion } from '@mui/types';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Label } from '../Label/';

export interface WsInputNumberProps {
  name: string;
  label?: string;
  variant?: 'standard' | 'outlined' | 'filled';
  size?: OverridableStringUnion<'small' | 'medium', FormControlPropsSizeOverrides>;
  disabled?: boolean;
  required?: boolean;
  error?: string;
  maxValue?: number;
  minValue?: number;
  defaultValue?: number | null | string;
  showMandatorySymbol?: boolean;
  placeholder?: string | undefined;
}

const WsInputNumber = ({
  name,
  label,
  variant = 'outlined',
  size = 'small',
  required = false,
  disabled = false,
  maxValue = 100000000,
  minValue = 0,
  defaultValue = null,
  showMandatorySymbol = false,
  placeholder,
}: WsInputNumberProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  return (
    <FormControl fullWidth variant={variant} size={size} required={required} disabled={disabled}>
      {label && (
        <Label>
          {label}
          {showMandatorySymbol ? ' *' : ''}
        </Label>
      )}

      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <TextField
            id={name}
            size={size}
            onChange={onChange}
            value={value}
            type="number"
            fullWidth
            defaultValue={defaultValue}
            InputProps={{
              inputProps: {
                max: { maxValue },
                min: { minValue },
              },
              inputMode: 'numeric',
            }}
            name={name}
            required={required}
            label={placeholder}
            disabled={disabled}
            variant={variant}
          />
        )}
      />
      {errors && <FormHelperText error>{errors[name]?.message}</FormHelperText>}
    </FormControl>
  );
};
export default WsInputNumber;
